import React from 'react';
import { observer } from 'mobx-react';

import Label from './Label';
import Image from './Image';
import Text from './Text';
import Radio from './Radio';

export default observer(({ name, value, currentValue, label, image, onChange }) => (
  <Label check isChecked={currentValue === value}>
    <Image value={value} src={`/images/dimensions/${image}`} />
    <Text>{label}</Text>
    <Radio value={value} name={name} onChange={onChange} />
  </Label>
));
